import {
  pageInfo,
  submitImport,
  excellentCaseEditInit,
  commentDelete,
  homePush,
  exportData,
  cancelData
} from './../api'
import {taskPkgAreaCitySelect, uploadImage} from '../../../../api'
const bestPractices = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    cancleResp: null,
    excellentCaseUpdInitObj: null,
    caseImgUploadObj: null,
    commentDeleteObj: null,
    homePush: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },
    //新增-提交
    SUBMIT_IMPORT_DATA(state, data){
      state.submitImportObj = data;
    },
    /**
     * 图片上传
     */
    CASE_IMG_UPLOAD(state, data) {
      state.caseImgUploadObj = data;
    },
    /**
     * 初始化
     */
    EXCELLENT_CASE_EDIT_INIT(state, data) {
      state.excellentCaseUpdInitObj = data;
    },
    /**
     * 详情
     */
    COMMENT_DELETE(state, data) {
      state.commentDeleteObj = data;
    },
    /**
     * 取消
     */
    CANCLE_DATA(state, data){
      state.cancleResp = data;
    },
    /**
     * 首页推送
     * @param state
     * @param data
     * @constructor
     */
    HOME_PUSH(state, data){
      state.homePush = data;
    },
    /**
     * 导出
     * @param state
     * @param data
     * @constructor
     */
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    /**
     * 新增-提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async submitImport({ commit }, obj) {
      let resp = await submitImport(obj);
      commit('SUBMIT_IMPORT_DATA', resp);
    },
    /**
     * 图片上传
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async caseImgUpload({ commit }, obj) {
      let resp = await uploadImage(obj);
      commit('CASE_IMG_UPLOAD', resp);
    },
    /**
     * 初始化
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async excellentCaseEditInit({ commit }, obj) {
      let resp = await excellentCaseEditInit(obj);
      commit('EXCELLENT_CASE_EDIT_INIT', resp);
    },
    /**
     * 查看详情
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async commentDelete({ commit }, obj) {
      let resp = await commentDelete(obj);
      commit('COMMENT_DELETE', resp);
    },
    /**
     * 列表删除
     */
    async cancelData({commit}, obj) {
      let resp = await cancelData(obj);
      commit('CANCLE_DATA', resp);
    },
    /**
     * 首页推送
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async homePush({commit}, obj) {
      let resp = await homePush(obj);
      commit('HOME_PUSH', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
  }
}
export default bestPractices



// WEBPACK FOOTER //
// ./src/page/case/bestPractices/store/bestPractices.store.js